module.exports = __webpack_public_path__ + "assets/img/JPMorgan-logo.a96aef6d.png";